<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
    </page-main>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="1000px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      append-to-body
    >
      <dict-options-edit-form
        ref="editForm"
        :orderCode="editFormDialogOptions.orderCode"
        :techCuttingCode="editFormDialogOptions.techCuttingCode"
        :techCuttingDetailCode="editFormDialogOptions.techCuttingDetailCode"
        :techCuttingGoodsCode="editFormDialogOptions.techCuttingGoodsCode"
        @reload="getData"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="$refs.editForm.save()">{{
          this.$l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
    <!-- <ChooseOrderGoodsSpecDialog
      :visible.sync="editFormDialogOptions.visible"
      :title="'添加订单产品规格'"
      :orderCode="editFormDialogOptions.orderCode"
      @confirm="onOrderGoodsConfirm"
      append-to-body
    /> -->
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'

import DictOptionsEditForm from './edit-form/index'
export default {
  components: {
    PageHeader,
    PageMain,
    DictOptionsEditForm,
  },

  mixins: [BaseTable],
  props: {
    orderCode: { type: String, default: '' },
    techCuttingCode: { type: String, default: '' },
    techCuttingDetailCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      editFormDialogOptions: {
        visible: false,
        keyID: '',
        companyCode: '',
      },
    }
  },
  computed: {},
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .techCuttingInfoGoodsListApi({
          techCuttingCode: this.techCuttingCode,
          techCuttingDetailCode: this.techCuttingDetailCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        edit: '编辑面料明细产品用量',
        add: '添加面料明细产品用量',
      }
      this.editFormDialogOptions = {
        visible: true,
        type,
        title: types[type],
        orderCode: this.orderCode,
        techCuttingCode: this.techCuttingCode,
        techCuttingDetailCode: this.techCuttingDetailCode,
        techCuttingGoodsCode: params.techCuttingGoodsCode,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    onOrderGoodsConfirm() {},
  },
}
</script>
